import Loader from "./Loader";
import { LoaderProps as InternalLoaderProps } from "./Loader";

export type LoaderProps = InternalLoaderProps;
export default Loader;
